module.exports = __webpack_public_path__ + "static/ly-7d33405d61cc312399cae64bd1f4924c.png";